import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import moment from "moment/moment";
import { STATIC_COL_WIDTH } from "@/Domains/DispositionManagement/Constants";
import { Theme } from "@mui/material";
import { useAppSelector } from "@/Redux/Redux";

interface ForeignStationProps {
    reservationToCompareWith: any;
    reservations: any;
    startForeign: boolean;
    contentWidth: number | undefined;
}

const useStyles = makeStyles()((theme: Theme) => ({
    foreignStation: {
        position: "absolute",
        backgroundColor: "red",
        marginTop: 24,
        height: 3,
        zIndex: 0,
    },
}));

const ForeignStation: FunctionComponent<ForeignStationProps> = ({
    reservationToCompareWith,
    reservations,
    startForeign,
    contentWidth,
}): JSX.Element => {
    if (contentWidth === undefined) {
        contentWidth = 0;
    } else {
        contentWidth -= STATIC_COL_WIDTH;
    }

    const { classes } = useStyles();
    const disposition = useAppSelector((state) => state.disposition);

    let startdate = null;
    let enddate = null;

    for (const key in reservations) {
        const reservation = reservations[key];
        const resEnddate = reservation.enddate || reservation.plannedEnddate;

        const fsenddate =
            reservationToCompareWith.enddate ||
            reservationToCompareWith.plannedEnddate;

        if (startForeign) {
            if (
                moment
                    .utc(resEnddate)
                    .isBefore(moment.utc(reservationToCompareWith.startdate))
            ) {
                startdate = resEnddate;
            }
        } else {
            if (
                moment.utc(reservation.startdate).isAfter(moment.utc(fsenddate))
            ) {
                enddate = reservation.startdate;
            }
        }
    }

    if (enddate === null) {
        enddate = moment.utc(disposition.dispositionEnddate).add(1, "day");
    }

    if (startForeign) {
        enddate = reservationToCompareWith.startdate;
    } else {
        startdate =
            reservationToCompareWith.enddate ||
            reservationToCompareWith.plannedEnddate;
    }

    if (
        moment
            .utc(startdate)
            .isBefore(moment.utc(disposition.dispositionStartdate))
    ) {
        if (
            moment
                .utc(enddate)
                .isBefore(moment.utc(disposition.dispositionStartdate))
        ) {
            startdate = enddate;
        } else {
            startdate = disposition.dispositionStartdate;
        }
    }

    if (startdate === null) {
        startdate = moment.utc(disposition.dispositionStartdate);
    }

    startdate = moment.utc(startdate);
    enddate = moment.utc(enddate);

    if (enddate.isBefore(disposition.dispositionStartdate)) {
        return <></>;
    }

    const dayWidthInPixel =
        ((disposition.dayWidth * contentWidth) / 100) * disposition.singleDay;

    const offsetDays = startdate.diff(
        moment.utc(disposition.dispositionStartdate),
        "days",
        true,
    );
    const duration = enddate.diff(startdate, "days", true) * dayWidthInPixel;

    const leftPos = offsetDays * dayWidthInPixel + STATIC_COL_WIDTH;

    return (
        <div
            className={classes.foreignStation}
            style={{ left: leftPos + "px", width: duration + "px" }}
        />
    );
};

export default ForeignStation;
